var _g, _path, _g2, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 266,
    viewBox: "0 0 270 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.19,
    filter: "url(#filter0_f_7370_48042)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.829,
    cy: 132.903,
    rx: 84.75,
    ry: 82.8239,
    fill: "#9A45F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7370_48042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 58,
    width: 150,
    height: 150
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.575 62.6045C129.226 57.6314 140.687 57.6313 150.338 62.6045L159.197 67.1699C160.835 68.014 162.541 68.7208 164.296 69.2822L173.789 72.3184C184.13 75.6263 192.233 83.7303 195.541 94.0713L198.578 103.563C199.139 105.318 199.845 107.024 200.689 108.662L205.255 117.522C210.228 127.174 210.228 138.634 205.255 148.285L200.689 157.145C199.845 158.783 199.14 160.488 198.578 162.243L195.541 171.736C192.233 182.077 184.13 190.18 173.789 193.488L164.296 196.525C162.541 197.087 160.835 197.793 159.197 198.637L150.338 203.202C140.687 208.175 129.226 208.175 119.575 203.202L110.715 198.637C109.077 197.793 107.371 197.087 105.616 196.525L96.124 193.488C85.783 190.18 77.679 182.077 74.3711 171.736L71.335 162.243C70.7736 160.488 70.0667 158.783 69.2227 157.145L64.6572 148.285C59.684 138.634 59.6841 127.174 64.6572 117.522L69.2227 108.662C70.0667 107.024 70.7736 105.319 71.335 103.563L74.3711 94.0713C77.6789 83.7301 85.7829 75.6262 96.124 72.3184L105.616 69.2822C107.371 68.7208 109.077 68.0139 110.715 67.1699L119.575 62.6045Z",
    fill: "#D9D9D9",
    stroke: "url(#paint0_linear_7370_48042)",
    strokeWidth: 0.342247
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7370_48042)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.491,
    y: 57.0955,
    width: 151.273,
    height: 151.273,
    rx: 75.6367,
    fill: "#C4C4C4",
    fillOpacity: 0.23,
    stroke: "url(#paint1_linear_7370_48042)",
    strokeWidth: 0.342247
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.34 62.1484C129.139 57.0992 140.774 57.0991 150.573 62.1484L159.433 66.7139C161.045 67.5448 162.724 68.2403 164.452 68.793L173.945 71.8291C184.445 75.1875 192.672 83.4158 196.03 93.915L199.066 103.407C199.619 105.135 200.315 106.815 201.146 108.428L205.712 117.287C210.761 127.086 210.761 138.722 205.712 148.521L201.146 157.38C200.315 158.993 199.619 160.671 199.066 162.399L196.03 171.893C192.672 182.392 184.444 190.619 173.945 193.978L164.452 197.014C162.724 197.566 161.045 198.263 159.433 199.094L150.573 203.659C140.775 208.708 129.139 208.708 119.34 203.659L110.48 199.094C108.868 198.263 107.188 197.566 105.46 197.014L95.9678 193.978C85.4686 190.619 77.2403 182.392 73.8818 171.893L70.8457 162.399C70.293 160.672 69.5976 158.993 68.7666 157.38L64.2012 148.521C59.1519 138.722 59.1519 127.086 64.2012 117.287L68.7666 108.428C69.5976 106.815 70.293 105.135 70.8457 103.407L73.8818 93.915C77.2402 83.4158 85.4685 75.1875 95.9678 71.8291L105.46 68.793C107.188 68.2402 108.868 67.5449 110.48 66.7139L119.34 62.1484Z",
    stroke: "url(#paint2_linear_7370_48042)",
    strokeWidth: 1.36899
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7370_48042",
    x: -0.00043869,
    y: 0.0000495911,
    width: 269.659,
    height: 265.807,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.0398,
    result: "effect1_foregroundBlur_7370_48042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7370_48042",
    x1: 134.956,
    y1: 54.8711,
    x2: 134.956,
    y2: 210.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0596A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197115,
    stopColor: "#3971F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423077,
    stopColor: "#9A45F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#FC7D06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807692,
    stopColor: "#F7E144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7370_48042",
    x1: 135.128,
    y1: 57.2666,
    x2: 135.128,
    y2: 208.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0596A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197115,
    stopColor: "#3971F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423077,
    stopColor: "#9A45F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#FC7D06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807692,
    stopColor: "#F7E144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7370_48042",
    x1: 134.956,
    y1: 54.8711,
    x2: 134.956,
    y2: 210.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0596A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197115,
    stopColor: "#3971F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423077,
    stopColor: "#9A45F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#FC7D06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807692,
    stopColor: "#F7E144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4626"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserShape);
export default __webpack_public_path__ + "static/media/userShape.8fb0ebc556f25092b59d98e992e7bc0c.svg";
export { ForwardRef as ReactComponent };